<div *ngFor="let item of items; let index = index">
    <div class="header"
         (click)="toggleExpanded(index)">
        <span class="circle-outline"
              *ngIf="!grouperOnly"
              [class.selected]="item.selected"
              (click)="toggleSelected($event, index)">
        </span>
        <i class="fa fa-cog" *ngIf="grouperOnly"></i>
        <div class="text">
            <strong class="name">{{ item.name }}</strong>
            <div class="description">{{ item.description }}</div>
        </div>
        <p class="info">{{ item.info }}</p>
        <div class="button-container" *ngIf="item.hasNavigation">
            <button class="circular-button" (click)="navigateTo($event, item.link)">
                <i class="fa fa-share"></i>
            </button>
        </div>
    </div>

    <div class="extension" [class.hidden]="!item.expanded">
        <div class="empty-content" *ngIf="!hasContent(index)">
            <i class="fa fa-frown-o"></i>
            <p>{{ 'admin.toolMaintenancePlans.accordion.nothing' | translate }}</p>
            <p class="bold">{{ 'admin.toolMaintenancePlans.accordion.yet' | translate }}</p>
        </div>
        <app-grouper-list *ngIf="hasContent(index)"
                          [dropdownItems]="item.items"
                          [items]="item.selectedItems || []"
                          [index]="item.id ?? index"
                          [readonly]="readonly"
                          [grouperOnly]="grouperOnly"
                          (select)="onSelect($event)"
                          (itemClicked)="onItemClicked($event)">
        </app-grouper-list>
    </div>
</div>
